import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType, redirectingProfileEnum } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";
import { profileType } from "@utils/enum";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "teu", label: "Total TEUs", two_table_header: "Total TEUs" },
  { value: "weight", label: "Total Weight", two_table_header: "Total Weight (kg)" },
  { value: "value", label: "Shipment Value (USD)", two_table_header: "Total Value (USD)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "teu", label: "TEUs", table_header: "Total TEU" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
];
export const defaultData = {
  name: "US Imports",
  showFacilityFilter: true,
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsRangeDownloadPresent: true,
  isShipmentGridNew: true,
  isBooleanFilter: true,
  isUIGridNew: true,
  isUEGridNew: true,
  isViewAllGridNew: true,
  changedPayloadForExcel: true,
  autosuggestLang: "EN",
  isHandleTrademoAccount: true,
  isImpExpGraph: true,
  showUiTrends: true,
  showTwoLevel: true,
  oldPayloadType: true,
  analyticsDefault: analyticDropdownOptions[1].value,
  isFilterGroupingPresent: true,
  exportPDFInAnalytics: false,
  exportPDFInAnalyticsFrontend: true,
  minimumDateAllowed: "2014-01-01",
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
    logistic: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "teu", label: "TEUs", table_header: "Total TEU" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Value (USD)" },
  ],
  logistics_sort_option: [{ value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" }],
  apiEndPoints: {
    getArrivalDate: getApiUrl("getLatestArrivalDate"),
    getSearchResult: getApiUrl("searchUS"),
    getAnalyticsData: getApiUrl("analytics/analyticsUS"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel"),
    downloadUniqueImporterExporter: getApiUrl("createExcelImporterExporter"),
    getShipmentByID: getApiUrl("getSupplierData"),
    getShipmentDownloadData: getApiUrl("renderToPdf"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/analyticsUSViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("importerExporterGraph"),
  },
  isAdvancedSearchAvailable: true,
  country_small: globalCountryDetails.us_import.country_small,
  countryCaps: globalCountryDetails.us_import.country_caps,
  product_id: globalCountryDetails.us_import.product_id,
  compare_product_id: globalCountryDetails.us_import.compareProduct,
  country_CamelCase: globalCountryDetails.us_import.product_id,
  countryCode: globalCountryDetails.us_import.countryCode,
  countryType: globalCountryDetails.us_import.countryType,
  manyCountryType: globalCountryDetails.us_import.manyCountryType,
  countryTypeCode: globalCountryDetails.us_import.countryTypeCode,
  redirectionID: globalCountryDetails.us_import.redirectionID,
  analyticsCountryID: globalCountryDetails.us_import.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipments Arrival Date Range",
  monthRangeHeading: "Month of Export",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: true,
    logistics: true,
    whatYouAreMissing: true,
    reports: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    logistics: true,
    ports: true,
    product_category: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.us_import.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    value: "shipmentValue",
    proximity: "buyerZipCode",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortRegion",
    portOfUnlading: "standardUnladingPortRegion",
    vocc: "standardVoccName",
    nvocc: "standardNvoccName",
    freightForwarder: "standardFreightForwarderName",
    tradeLane: "standardTradeLane",
    productCategory: "productCategory",
  },
  filterObj: {
    billType: "billType",
    include_master_bill: "include_master_bill",
    buyerCity: "buyerCity",
    buyerState: "buyerState",
    buyerZipCode: "buyerZipCode",
    carrierName: "carrierName",
    consigneeCountryRegion: "consigneeCountryRegion",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
    consigneeCountry: "consigneeCountry",
    containerType: "containerType",
    countryRegion: "countryRegion",
    equipmentDescription: "equipmentDescription",
    exporters: "exporters",
    is_supplier: "is_supplier",
    is_buyer: "is_buyer",
    foreignPort: "foreignPort",
    foreignPortRegion: "foreignPortRegion",
    hsCode: "hsCode",
    importers: "importers",
    lclFCL: "lclFCL",
    noOfUniqueContainers: "noOfUniqueContainers",
    notifyParty: "notifyParty",
    secondaryNotifyParties: "secondaryNotifyParties",
    standardNvoccName: "standardNvoccName",
    standardFreightForwarderName: "standardFreightForwarderName",
    portOfArrival: "portOfArrival",
    portOfDestination: "portOfDestination",
    portOfDestinationRegion: "portOfDestinationRegion",
    standardUnladingPortName: "standardUnladingPortName",
    standardUnladingPortRegion: "standardUnladingPortRegion",
    vesselType: "vesselType",
    vesselTypeRegion: "vesselTypeRegion",
    stateRegion: "stateRegion",
    supplierCountry: "supplierCountry",
    teu: "teu",
    transportation: "transportation",
    typeOfService: "typeOfService",
    standardVoccName: "standardVoccName",
    weight: "weight",
    shipmentValue: "shipmentValue",
    shipperFacility: "shipperFacility",
    consigneeFacility: "consigneeFacility",
    derivedShipperMasterName: "derivedShipperMasterName",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    shipperCity: "shipperCity",
    sixDigitHsCode: "sixDigitHsCode",
    standardLadingPortName: "standardLadingPortName",
    standardLadingPortRegion: "standardLadingPortRegion",
    containerDimensionRegion: "containerDimensionRegion",
    containerDescriptionRegion: "containerDescriptionRegion",
    standardTradeLane: "standardTradeLane",
    vesselName: "vesselName",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  booleanFilterObj: {
    include_master_bill: "include_master_bill",
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    noOfUniqueContainers: "noOfUniqueContainers",
    weight: "weight",
    teu: "teu",
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    noOfUniqueContainers: [],
    weight: [],
    teu: [],
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    consigneeCountryRegion: "consigneeCountry",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
    countryRegion: "supplierCountry",
    stateRegion: "buyerState",
    standardUnladingPortRegion: "standardUnladingPortName",
    portOfDestinationRegion: "portOfDestination",
    foreignPortRegion: "foreignPort",
    vesselTypeRegion: "vesselType",
    standardLadingPortRegion: "standardLadingPortName",
    containerDimensionRegion: "containerDimension",
    containerDescriptionRegion: "containerDescription",
  },
  emptyFilterObj: {
    billType: [],
    buyerCity: [],
    buyerState: [],
    buyerZipCode: [],
    carrierName: [],
    consigneeCountryRegion: [],
    consigneeJurisdictionCountryRegion: [],
    shipperJurisdictionCountryRegion: [],
    consigneeCountry: [],
    containerType: [],
    countryRegion: [],
    equipmentDescription: [],
    exporters: [],
    is_supplier: [],
    is_buyer: [],
    foreignPort: [],
    foreignPortRegion: [],
    hsCode: [],
    importers: [],
    lclFCL: [],
    vesselName: [],
    noOfUniqueContainers: [],
    notifyParty: [],
    secondaryNotifyParties: [],
    standardNvoccName: [],
    standardFreightForwarderName: [],
    portOfArrival: [],
    portOfDestination: [],
    portOfDestinationRegion: [],
    standardUnladingPortName: [],
    standardUnladingPortRegion: [],
    vesselType: [],
    vesselTypeRegion: [],
    stateRegion: [],
    supplierCountry: [],
    teu: [],
    transportation: [],
    typeOfService: [],
    standardVoccName: [],
    weight: [],
    include_master_bill: [],
    shipmentValue: [],
    sections: [],
    shipperFacility: [],
    consigneeFacility: [],
    derivedShipperMasterName: [],
    derivedConsigneeMasterName: [],
    productCategory: [],
    industryCategory: [],
    shipperCity: [],
    sixDigitHsCode: [],
    standardLadingPortName: [],
    standardLadingPortRegion: [],
    containerDimensionRegion: [],
    containerDimension: [],
    containerDescriptionRegion: [],
    containerDescription: [],
    standardTradeLane: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
  },
  defaultBooleanFilterObj: {
    include_master_bill: true,
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    billType: false,
    buyerCity: false,
    buyerState: false,
    buyerZipCode: false,
    carrierName: false,
    consigneeCountryRegion: false,
    consigneeJurisdictionCountryRegion: false,
    shipperJurisdictionCountryRegion: false,
    containerType: false,
    countryRegion: false,
    equipmentDescription: false,
    exporters: false,
    is_supplier: false,
    is_buyer: false,
    foreignPort: false,
    foreignPortRegion: false,
    hsCode: false,
    importers: false,
    lclFCL: false,
    vesselName: false,
    noOfUniqueContainers: false,
    notifyParty: false,
    secondaryNotifyParties: false,
    standardNvoccName: false,
    standardFreightForwarderName: false,
    portOfArrival: false,
    portOfDestination: false,
    portOfDestinationRegion: false,
    standardUnladingPortName: false,
    standardUnladingPortRegion: false,
    vesselType: false,
    vesselTypeRegion: false,
    stateRegion: false,
    supplierCountry: false,
    teu: false,
    transportation: false,
    typeOfService: false,
    standardVoccName: false,
    weight: false,
    shipmentValue: false,
    sections: false,
    derivedShipperMasterName: false,
    derivedConsigneeMasterName: false,
    productCategory: false,
    industryCategory: false,
    shipperCity: false,
    sixDigitHsCode: false,
    standardLadingPortName: false,
    standardLadingPortRegion: false,
    containerDimensionRegion: false,
    containerDescriptionRegion: false,
    shipperFacility: false,
    consigneeFacility: false,
    standardTradeLane: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
  },
  specialMappingFields: {},
  normalfilterList: [
    { heading: "Filter by Consignee Standardized Name", categoryName: categoryType.consigneeDetails, eventKey: "27", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Standardized Name", categoryName: categoryType.shipperDetails, eventKey: "28", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee", categoryName: categoryType.consigneeDetails, eventKey: "3", key: "importers", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search Consignees", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper", categoryName: categoryType.shipperDetails, eventKey: "4", key: "exporters", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search Shippers", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Include Master Bills", categoryName: categoryType.billlading, eventKey: "1", key: "include_master_bill", type: filterType.radioFilter, optionOne: "Exclude", optionTwo: "Include", label: "Include Master Bills", infoText: "Include Master Bills with linked house bills" },
    { heading: "Filter by Country of Export", categoryName: categoryType.shipperDetails, eventKey: "2", key: "countryRegion", altKey: "supplierCountry", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search Country of Export", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Type", categoryName: categoryType.shipperDetails, eventKey: "27", key: "is_supplier", type: filterType.normalFilter, label: "Shipper Type", viewAllPlaceHolder: "Search Shipper Type", emptyFilterText: "", searchFilterString: "", mappedValues: { NO: "Logistics Provider", YES: "Supplier" }, showInput: false },
    { heading: "Filter by Country of Import", categoryName: categoryType.consigneeDetails, eventKey: "25", key: "consigneeCountryRegion", altKey: "consigneeCountry", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search Country of Import", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Jurisdiction Country", categoryName: categoryType.consigneeDetails, eventKey: "25", key: "consigneeJurisdictionCountryRegion", altKey: "consigneeJurisdictionCountry", type: filterType.localizeFilter, label: "Consignee Jurisdiction Country", viewAllPlaceHolder: "Search Consignee Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Jurisdiction Country", categoryName: categoryType.shipperDetails, eventKey: "25", key: "shipperJurisdictionCountryRegion", altKey: "shipperJurisdictionCountry", type: filterType.localizeFilter, label: "Shipper Jurisdiction Country", viewAllPlaceHolder: "Search Shipper Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee State", categoryName: categoryType.consigneeDetails, eventKey: "5", key: "stateRegion", altKey: "buyerState", type: filterType.localizeFilter, label: "Consignee State", viewAllPlaceHolder: "Search Consignee State", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee City", categoryName: categoryType.consigneeDetails, eventKey: "6", key: "buyerCity", type: filterType.normalFilter, label: "Consignee City", viewAllPlaceHolder: "Search Consignee City", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Zip Code", categoryName: categoryType.consigneeDetails, eventKey: "7", key: "buyerZipCode", type: filterType.proximityFilter, label: "Consignee Zip Code", viewAllPlaceHolder: "Search Consignee Zipcode", emptyFilterText: "No matching Consignee Zipcode found for this search", searchFilterString: "" },
    { heading: "Filter by Consignee Type", categoryName: categoryType.consigneeDetails, eventKey: "27", key: "is_buyer", type: filterType.normalFilter, label: "Consignee Type", viewAllPlaceHolder: "Search Consignee Type", emptyFilterText: "", searchFilterString: "", mappedValues: { NO: "Logistics Provider", YES: "Supplier" }, showInput: false },
    { heading: "Filter by Port of Lading", categoryName: categoryType.ports, eventKey: "28", key: "standardLadingPortRegion", altKey: "standardLadingPortName", type: filterType.localizeFilter, label: "Port of Lading", viewAllPlaceHolder: "Search Port of Lading", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Foreign Port of Lading", categoryName: categoryType.ports, eventKey: "10", key: "foreignPortRegion", altKey: "foreignPort", type: filterType.localizeFilter, label: "Foreign Port of Lading", viewAllPlaceHolder: "Search Foreign Port of Lading", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port of Unlading", categoryName: categoryType.ports, eventKey: "8", key: "standardUnladingPortRegion", altKey: "standardUnladingPortName", type: filterType.localizeFilter, label: "Port of Unlading", viewAllPlaceHolder: "Search Port of Unlading", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port of Destination", categoryName: categoryType.ports, eventKey: "9", key: "portOfDestinationRegion", altKey: "portOfDestination", type: filterType.localizeFilter, label: "Port of Destination", viewAllPlaceHolder: "Search Port of Destination", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Trade Lanes", categoryName: categoryType.ports, eventKey: "29", key: "standardTradeLane", type: filterType.normalFilter, label: "Trade Lanes", viewAllPlaceHolder: "Search Trade Lane", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by VOCC", categoryName: categoryType.carrierDetails, eventKey: "11", key: "standardVoccName", type: filterType.upgradeCheckboxFilter, label: "VOCC", viewAllPlaceHolder: "Search VOCC", emptyFilterText: "", searchFilterString: "", infoText: "Vessel Operating Common Carrier", upgradeText: "To access VOCC filters you need to upgrade to higher plan.", isParanthesesCapital: true },
    { heading: "Filter by NVOCC", categoryName: categoryType.carrierDetails, eventKey: "12", key: "standardNvoccName", type: filterType.upgradeCheckboxFilter, label: "NVOCC", viewAllPlaceHolder: "Search NVOCC", emptyFilterText: "", searchFilterString: "", infoText: "Non Vessel Operating Common Carrier", upgradeText: "To access NVOCC filters you need to upgrade to higher plan.", isParanthesesCapital: true },
    { heading: "Filter by Product Category", categoryName: categoryType.cargoDetails, eventKey: "13", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Type Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: categoryType.cargoDetails, eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Type Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: categoryType.cargoDetails, eventKey: "13", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Type to Search HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Notify Party", categoryName: categoryType.consigneeDetails, eventKey: "14", key: "notifyParty", type: filterType.normalFilter, label: "Notify Party", viewAllPlaceHolder: "Search Notify Party", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Secondary Notify Party", categoryName: categoryType.consigneeDetails, eventKey: "14", key: "secondaryNotifyParties", type: filterType.normalFilter, label: "Secondary Notify Party", viewAllPlaceHolder: "Search Secondary Notify Party", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Carrier Name", categoryName: categoryType.carrierDetails, eventKey: "15", key: "carrierName", type: filterType.normalFilter, label: "Carrier Name", viewAllPlaceHolder: "Search Carrier Name", emptyFilterText: "", searchFilterString: "", isParanthesesCapital: true },
    { heading: "Filter by Type of Service", categoryName: categoryType.freightType, eventKey: "16", key: "typeOfService", type: filterType.normalFilter, label: "Freight Service", viewAllPlaceHolder: "Search Type of Service", emptyFilterText: "", searchFilterString: "", upgradeText: "To access Type of Service filters you need to upgrade to higher plan." },
    { heading: "Filter by Container Type", categoryName: categoryType.freightType, eventKey: "17", key: "containerDescriptionRegion", type: filterType.localizeFilter, altKey: "containerDescription", label: "Container Type", viewAllPlaceHolder: "Search Container Type", emptyFilterText: "", searchFilterString: "", upgradeText: "To access Container Type filters you need to upgrade to higher plan." },
    { heading: "Filter by Container Dimension", categoryName: categoryType.freightType, eventKey: "30", key: "containerDimensionRegion", type: filterType.localizeFilter, altKey: "containerDimension", label: "Container Dimension", viewAllPlaceHolder: "Search Container Dimension", emptyFilterText: "", searchFilterString: "", upgradeText: "To access Container Dimension filters you need to upgrade to higher plan.", isLowerCase: true },
    { heading: "Filter by Equipment Description", categoryName: categoryType.freightType, eventKey: "18", key: "equipmentDescription", type: filterType.normalFilter, label: "Freight Description", viewAllPlaceHolder: "Search Equipment Description", emptyFilterText: "", searchFilterString: "", upgradeText: "To access Equipment Description filters you need to upgrade to higher plan." },
    { heading: "Filter by Number of Containers", categoryName: categoryType.freightType, eventKey: "19", key: "noOfUniqueContainers", type: filterType.boxFilter, label: "Number of Containers", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Weight", categoryName: categoryType.cargoDetails, eventKey: "20", key: "weight", type: filterType.boxFilter, label: "Weight", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false },
    { heading: "Filter by TEU", categoryName: categoryType.cargoDetails, eventKey: "21", key: "teu", type: filterType.boxFilter, label: "TEU", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "Twenty-feet Equivalent Unit", upgradeText: "To access TEUs filters you need to upgrade to higher plan.", showInput: false },
    { heading: "Filter by Bill of Lading", categoryName: categoryType.billlading, eventKey: "22", key: "billType", type: filterType.normalFilter, label: "Bill of Lading Type", viewAllPlaceHolder: "Search Bill of Lading", emptyFilterText: "", searchFilterString: "", upgradeText: "To access Bill of Lading filters you need to upgrade to higher plan." },
    { heading: "Filter by Is Containerised", categoryName: categoryType.freightType, eventKey: "23", key: "transportation", type: filterType.normalFilter, label: "Is Containerised", viewAllPlaceHolder: "Search Is Containerised", emptyFilterText: "", searchFilterString: "", upgradeText: "To access Is Containerised filters you need to upgrade to higher plan.", showInput: false },
    { heading: "Filter by LCL / FCL", categoryName: categoryType.freightType, eventKey: "24", key: "lclFCL", type: filterType.normalFilter, label: "LCL / FCL", viewAllPlaceHolder: "Search Container Load", emptyFilterText: "", searchFilterString: "", upgradeText: "To access Conatiner Load filters you need to upgrade to higher plan.", isTextCapitalise: true, showInput: false },
    { heading: "Filter by Shipment Value (USD)", categoryName: "cargoDetails", eventKey: "25", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value", viewAllPlaceHolder: "Search Shipment Value", emptyFilterText: "", searchFilterString: "", upgradeText: "To access Conatiner Load filters you need to upgrade to higher plan.", isTextCapitalise: true },
    { heading: "Filter by Vessel Name", categoryName: categoryType.freightType, eventKey: "31", key: "vesselName", type: filterType.normalFilter, label: "Vessel Name", viewAllPlaceHolder: "Search Vessel Name", emptyFilterText: "", searchFilterString: "", isParanthesesCapital: true },
    { heading: "Filter by Vessel Type", categoryName: categoryType.freightType, eventKey: "27", key: "vesselTypeRegion", altKey: "vesselType", type: filterType.localizeFilter, label: "Vessel Type", viewAllPlaceHolder: "Search Vessel Type", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: categoryType.cargoDetails, eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
    { heading: "Filter by Freight Forwarder", categoryName: categoryType.carrierDetails, eventKey: "12", key: "standardFreightForwarderName", type: filterType.upgradeCheckboxFilter, label: "Freight Forwarder", viewAllPlaceHolder: "Search Freight Forwarder", emptyFilterText: "", searchFilterString: "", isParanthesesCapital: true },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: true, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "derived_hs_codes", label: "HS Code" },
    { key: "derived_estimated_hs_code", label: "Estimated HS Code" },
    { key: "consignee_name", label: "Consignee Name" },
    { key: "derived_consignee_master_name", label: "Consignee Standardized Name" },
    { key: "derived_shipper_master_name", label: "Shipper Standardized Name" },
    { key: "derived_consignee_full_addr", label: "Consignee Address" },
    { key: "derived_consignee_master_company_id", label: "Consignee Master Company Id" },
    { key: "derived_consignee_std_name", label: "Consignee STD Name" },
    { key: "derived_hs_codes_ml", label: "Derived Hs Codes" },
    { key: "derived_importer_address", label: "Importer Address" },
    // { key: 'derived_new_consignee_id_name_combined', label: 'Consignee ID Name Combined' },
    { key: "derived_new_shipper_id_name_combined", label: "Shipper ID Name Combined" },
    { key: "derived_shipper_address", label: "Shipper Address" },
    { key: "derived_shipper_company_id", label: "Shipper Company Id" },
    { key: "derived_shipper_master_company_id", label: "Shipper Master Company Id" },
    { key: "derived_shipper_party_address", label: "Shipper Party Address" },
    { key: "equipment_description_code", label: "Equipment Description Code" },
    { key: "hazmat_description", label: "Hazmat Description" },
    { key: "hazmatclass_container_number", label: "Hazmat Container No." },
    { key: "identifier", label: "Identifier" },
    { key: "consignee_address_1", label: "Consignee Address" },
    { key: "derived_consignee_zip_code", label: "Consignee Zip Code" },
    { key: "derived_consignee_zip_code_clean", label: "Consignee Zip Code" },
    { key: "derived_consignee_city", label: "Consignee City" },
    { key: "derived_consignee_state", label: "Consignee State" },
    { key: "derived_country_of_origin", label: "Country of Export" },
    { key: "cargo_container_number", label: "Container Number" },
    { key: "cargo_description_sequence_number", label: "Cargo Description Sequence Number" },
    { key: "carrier_code", label: "Carrier Code" },
    { key: "consginee_comm_number", label: "Consginee Comm No." },
    { key: "consignee_address_2", label: "Consignee Address" },
    { key: "consignee_address_3", label: "Consignee Address" },
    { key: "consignee_address_4", label: "Consignee Address" },
    { key: "consignee_comm_number", label: "Consginee Comm No." },
    { key: "consignee_comm_number_qualifier", label: "Consginee Comm No. Qualifier" },
    { key: "container_container_number", label: "Container Container No." },
    { key: "conveyance_id", label: "Conveyance ID" },
    { key: "derived_cargo_container_number", label: "Conveyance ID" },
    { key: "derived_consignee_address", label: "Derived Consignee Address" },
    { key: "consignee_city", label: "Consignee City" },
    { key: "derived_consignee_company_id", label: "Derived Consignee Company Id" },
    { key: "consignee_contact_name", label: "Consignee Contact Name" },
    { key: "shipper_party_name", label: "Shipper Name" },
    { key: "shipper_party_address_1", label: "Shipper Address" },
    { key: "shipper_party_address_2", label: "Shipper Address" },
    { key: "shipper_party_address_3", label: "Shipper Address" },
    { key: "shipper_party_address_4", label: "Shipper Address" },
    { key: "derived_shipper_full_addr", label: "Shipper Address" },
    { key: "notify_party_address_1", label: "Notify Party Address" },
    { key: "notify_party_address_2", label: "Notify Party Address" },
    { key: "notify_party_address_3", label: "Notify Party Address" },
    { key: "notify_party_address_4", label: "Notify Party Address" },
    { key: "marks_and_numbers_container_number", label: "Marks and Number Container No." },
    { key: "notify_party_contact_name", label: "Notify Contact Name" },
    { key: "shiper_comm_number", label: "Shipper Number" },
    { key: "shipper_party_comm_number", label: "Shipper Party Number" },
    { key: "sub_house_bol_number", label: "House BOL Number" },
    { key: "tariff_container_number", label: "Tariff Container Number" },
    { key: "tariff_description_sequence_number", label: "Tariff Description Number" },
    { key: "vessel_name", label: "Vessel Name" },
    { key: "voyage_number", label: "Voyage Number" },
    { key: "shipper_party_contact_name", label: "Shipper Contact Name" },
    { key: "derived_port_of_arrival", label: "Port of Arrival" },
    { key: "derived_port_of_unlading", label: "Port of Unlading" },
    { key: "place_of_receipt", label: "Place of Receipt" },
    { key: "derived_carrier_name", label: "Carrier Name" },
    { key: "derived_product_keyword", label: "Product Keyword" },
    { key: "notify_party_name", label: "Notify Party Name" },
    { key: "derived_notify_party_name", label: "Notify Party Name" },
    { key: "notify_party_addr", label: "Notify Party Address" },
    { key: "master_bol_number", label: "Master Bill of Lading" },
    { key: "house_bol_number", label: "House Bill of Lading" },
    { key: "foreign_port_of_lading", label: "Foreign Port Of Lading" },
    { key: "manifest_quantity", label: "Quantity" },
    { key: "bill_type_code", label: "Bill Type Code" },
    { key: "derived_shipper_std_name", label: "Shipper Std. Name" },
    { key: "derived_notify_party_full_addr", label: "Notify party address" },
    { key: "derived_unique_product_keywords", label: "Product Description" },
    // { key: 'secondary_notify_party_1', label: 'Secondary notify party' },
    // { key: 'secondary_notify_party_2', label: 'Secondary notify party' },
    // { key: 'secondary_notify_party_3', label: 'Secondary notify party' },
    // { key: 'secondary_notify_party_4', label: 'Secondary notify party' },
    // { key: 'secondary_notify_party_5', label: 'Secondary notify party' },
    // { key: 'secondary_notify_party_6', label: 'Secondary notify party' },
    // { key: 'secondary_notify_party_7', label: 'Secondary notify party' },
    // { key: 'secondary_notify_party_8', label: 'Secondary notify party' },
    // { key: 'secondary_notify_party_9', label: 'Secondary notify party' },
    // { key: 'secondary_notify_party_10', label: 'Secondary notify party' },
    { key: "derived_secondary_notify_parties", label: "Secondary notify party" },
    { key: "derived_product_keywords", label: "Product keywords" },
    // { key: "derived_vocc_name", label: "VOCC Name" },
    // { key: "derived_nvocc_name", label: "NVOCC Name" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "master_bill_consignee_name", label: "Master Bill Consignee Name" },
    { key: "master_bill_shipper_name", label: "Master Bill Shipper Name" },
    { key: "master_bill_carrier_name", label: "Master Bill Carrier Name" },
    { key: "master_bill_notify_party", label: "Master Bill Notify Party Name" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Name" },
    { key: "imo_number", label: "IMO Number" },
    { key: "mmsi_number", label: "MMSI Number" },
    { key: "record_type_60_61", label: "Container Details" },
    { key: "record_type_60_62", label: "Additional Container Details" },
    { key: "record_type_70_71", label: "Hazmat Description" },
    { key: "record_type_80", label: "Marks and Numbers" },
    { key: "derived_vocc_name_id_combined", label: "VOCC" },
    { key: "derived_freight_forwarder_name_id_combined", label: "Freight Forwarder" },
    { key: "derived_nvocc_name_id_combined", label: "NVOCC" },
    { key: "derived_port_of_lading", label: "Port of Lading" },
    { key: "derived_port_of_unlading", label: "Port of Unlading" },
    { key: "derived_trade_lane", label: "Trade Lane" },
    { key: "derived_vocc_code", label: "VOCC SCAC Code" },
    { key: "derived_nvocc_code", label: "NVOCC SCAC Code" },
  ],
  shipmentSorting: [
    { columnKey: "actual_arrival_date", value: "date", isDefault: true },
    { columnKey: "derived_weight", value: "weight", isDefault: false },
    { columnKey: "derived_shipment_teu", value: "teu", isDefault: false },
    { columnKey: "derived_shipment_value", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "TEUs", columnKey: "teu", value: "teu", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
  ],
  importerSorting: [
    { name: "TEUs", columnKey: "teu", value: "teu", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
  ],
  logisticsSorting: [{ name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true }],
  sortKeyMap: {
    date: "actual_arrival_date",
    weight: "derived_weight",
    teu: "derived_shipment_teu",
    shipment_value: "derived_shipment_value",
  },
  sortKeyUniqueImpExpMap: {
    teu: "teu",
    date: "doc_count",
    weight: "weight",
    shipment_value: "shipment_value",
  },
  analyticsHeaderItems: [
    { label: "Total Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total TEUs", key: "total_teu", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipments Weight", key: "total_weight", valueSuffix: "Kg", valuePrefix: "" },
    { label: "Total Shipments Value", key: "total_value", valueSuffix: "", valuePrefix: "USD" },
  ],
  levelTwoAnalyticsHeaderItems: {},
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryRegion", filterKey2: "consigneeCountryRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trends", filterKey: "", label: "Import Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false, modalHeader: "Import Trends" },
    { key: "country_of_origin", filterKey: "countryRegion", label: "Countries of Export", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_port_of_unlading", modalHeader: "Countries of Export" },
    { key: "derived_port_of_unlading", filterKey: "standardUnladingPortRegion", label: "Ports of Unlading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "foreign_port_of_lading", modalHeader: "US Ports of Unlading", profileType: redirectingProfileEnum.portOfUnlading.key, isFavourite: true, profileTypeKey: profileType.ports },
    { key: "foreign_port_of_lading", filterKey: "foreignPortRegion", label: "Foreign Port of Lading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_port_of_unlading", modalHeader: "Foreign Port of Lading" },
    { key: "derived_consignee_state", filterKey: "stateRegion", label: "Consignee States", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "country_of_origin", modalHeader: "Consignee States" },
    { key: "notify_party_name", headerLabel: "Notify Parties", filterKey: "notifyParty", label: "Notify Parties", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name", modalHeader: "Notify Parties" },
    { key: "derived_secondary_notify_parties", headerLabel: "Secondary Notify Parties", filterKey: "secondaryNotifyParties", label: "Secondary Notify Parties", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name", modalHeader: "Secondary Notify Parties" },
    { key: "trade_port", filterKey1: "foreignPortRegion", filterKey2: "standardUnladingPortRegion", label: "Trade Routes (Foreign Port of Lading → Port of Unlading)", headerOne: "Foreign Port of Lading", headerTwo: "US Port of Unlading", filterOne: "filterPortOflading", filterTwo: "filterPortOfUnlading", keyOne: "port", keyOneCountryCode: "countryCode", keyTwo: "portOfUnlading", keyTwoCountryCode: "portCountryCode", type: analyticsType.topTwo, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", grpType: "multi", modalHeader: "Trade Routes (Foreign Port of Lading → US Port of Unlading)" },
    // { key: "trade_country", filterKey1: "countryRegion", filterKey2: "stateRegion", label: "Trade Routes (Country of Export → Consignee State)", headerOne: "Country of Export", headerTwo: "Consignee State", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2", keyOneCountryCode: "field1CountryCode", type: analyticsType.topTwo, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", grpType: "multi", modalHeader: "Trade Routes(Country of Export → Consignee State)" },
    { key: "derived_nvocc_name", filterKey: "standardNvoccName", label: "NVOCC", type: analyticsType.verticalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", modalHeader: "NVOCC", profileType: redirectingProfileEnum.nvocc.key, isFavourite: true, profileTypeKey: profileType.logistics },
    { key: "derived_vocc_name", filterKey: "standardVoccName", label: "VOCC", type: analyticsType.verticalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", modalHeader: "VOCC", profileType: redirectingProfileEnum.vocc.key, isFavourite: true, profileTypeKey: profileType.logistics },
    { key: "derived_carrier_name", filterKey: "carrierName", label: "Carriers", type: analyticsType.verticalBar, showTrends: true, showlevelTwo: true, defaultKey: "country_of_origin", modalHeader: "Carriers" },
    { key: "hs_code", headerLabel: "HS Codes", filterKey: "hsCode", label: "2 digit HS Codes", type: analyticsType.hsCode, infoText: "Analytics data is based on the summary of the shipments obtained through a search query.<br/> Hence the data may contain aggregated results for all products, HS Codes present in the search results.", showlevelTwo: false, modalHeader: "2 digit HS Codes" },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "port_of_lading", headerLabel: "Port of Lading", filterKey: "standardLadingPortRegion", label: "Port of Lading ", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name", profileType: redirectingProfileEnum.portOfLading.key, isFavourite: true, profileTypeKey: profileType.ports },
    { key: "trade_port_of_lading_to_unlading", filterKey1: "standardLadingPortRegion", filterKey2: "standardUnladingPortRegion", label: "Port Pairs (Port of Lading → Port of Unlading)", headerOne: "Ports of Lading", headerTwo: "Ports of Unlading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", grpType: "multi", modalHeader: "Trade Routes(Port of lading → US Port of Unlading)", profileType: redirectingProfileEnum.portOfUnlading.key },
    { key: "derived_freight_forwarder_name", filterKey: "standardFreightForwarderName", label: "Freight Forwarder", type: analyticsType.verticalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", modalHeader: "Freight Forwarder", profileType: redirectingProfileEnum.freightForwarder.key, isFavourite: true, profileTypeKey: profileType.logistics },
    { key: "derived_trade_lane", filterKey1: "standardTradeLane", filterKey2: "standardTradeLane", label: "Top Trade Lanes(Lading Region → Unlading Region)", headerOne: "Lading Region", headerTwo: "Unlading Region", keyOne: "key1fullform", keyTwo: "key2fullform", filterOne: "filterKey", filterTwo: "filterKey", type: analyticsType.topTwo, showTrends: true, showlevelTwo: true, defaultKey: "derived_carrier_name", grpType: "multi", modalHeader: "Top Trade Lanes(Lading Region → Unlading Region)", profileType: redirectingProfileEnum.tradeLane.key, cityOne: "key1", cityTwo: "key2", isFavourite: true, profileTypeKey: profileType.tradeLanes },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "actual_arrival_date", name: "Arrival Date", selector: "actual_arrival_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 0, wrap: true, miWidth: "105px", maWidth: "105px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_hs_codes_string", name: "HS Code", maxWidth: "120px !important", minWidth: "120px !important", selector: "derived_hs_codes_string", wrap: true, isSliceEnabled: true, sliceLength: 40, alternateSelector: "derived_hs_codes_string_estimated", alternateValueCheckField: "derived_hs_codes_string_estimated_is_present", dataTip: "", type: "conditionalBlur", grow: 1, isInfoText: true, infoText: "HS Code for some shipments may be estimated based on the shipment data. For differentiation between actual and estimated HS Code please view the Shipment Details.", upgradeText: "To view estimated HS Code, you would need to upgrade to higher plan.", miWidth: "100px", maWidth: "100px" },
    { key: "derived_unique_product_keywords", name: "Product", selector: "derived_unique_product_keywords", tooltipValue: "derived_unique_product_keywords", type: "", grow: 1, wrap: true, isSliceEnabled: true, sliceLength: 40, miWidth: "120px", maWidth: "120px" },
    { key: "manifest_quantity", name: "Quantity", selector: "derived_quantity_unit", secondarySelector: "derived_quantity_unit", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "derived_weight", name: "Weight (kg)", selector: "derived_weight", dataTip: "", type: "", sortable: true, grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "derived_shipment_teu", name: "TEUs", selector: "derived_shipment_teu", valueCheckField: "derived_shipment_teu_is_present", type: "conditionalBlur", dataTip: "", sortable: true, grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view TEU, you would need to upgrade to higher plan.", miWidth: "60px", maWidth: "60px" },
    { key: "derived_consignee_master_name", name: "Consignee", selector: "derived_consignee_master_name", alternateSelector: "consignee_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "shipper_party_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_country_of_origin", name: "Country of Export", selector: "derived_country_of_origin", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "derived_shipment_value", name: "Estimated Shipment Value (USD)", selector: "derived_shipment_value", valueCheckField: "derived_shipment_value_is_present", type: "conditionalBlur", dataTip: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view estimated shipment value, you would need to upgrade to higher plan.", miWidth: "120px", maWidth: "120px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: true, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", sortable: true, selector: "doc_count", dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight(kg)", sortable: true, selector: "weight", dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "teu", name: "TEUs", type: "conditionalBlur", sortable: true, selector: "teu", wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view TEU, you would need to upgrade to higher plan." },
    { key: "shipment_value", name: "Shipment Value (USD)", sortable: true, selector: "shipment_value", dataTip: "", type: "conditionalBlur", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view Shipment, you would need to upgrade to higher plan." },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", sortable: true, selector: "doc_count", dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight(kg)", sortable: true, selector: "weight", dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "teu", name: "TEUs", type: "conditionalBlur", sortable: true, selector: "teu", wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view TEU, you would need to upgrade to higher plan." },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "conditionalBlur", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view Shipment, you would need to upgrade to higher plan." },
    // { key: "city", showUiUeTwoLevel: false, name: "City", selector: "city", dataTip: "", type: "", isFirstLetterCapital: true },
    // { key: "zipcode", showUiUeTwoLevel: false, name: "Zip Code", selector: "zipcode", dataTip: "", type: "" },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
  ],
  logisticsTableColumn: [
    { key: "id", showUiUeTwoLevel: true, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", id: "hashed_id", type: "companyRedirect", grow: 1, fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, isFirstLetterCapital: true, minWidth: "200px" },
    { key: "company_type", name: "Type", type: "conditionalBlur", selector: "company_type", wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view TEU, you would need to upgrade to higher plan." },
    { key: "doc_count", name: "Shipment Occurence", selector: "doc_count", dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, sortable: true },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "derived_country_of_origin", showUiUeTwoLevel: false, name: "Country", selector: "country", dataTip: "", type: "", grow: 1, wrap: true, isFirstLetterCapital: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Date of Arrival", value: "actual_arrival_date", dateFormat: true, monthFormat: false, infoText: "Date shipment arrived on US port" },
        { label: "Master Bill of Lading", value: "master_bol_number", capitalize: true, infoText: "A bill no. issued by shipping/carrier  companies to the freight forwarder" },
        { label: "House Bill of Lading", value: "house_bol_number", capitalize: true, infoText: "A bill no. issued to the shipper/exporter by the freight forwarder" },
        { label: "Bill of Lading Type", value: "bill_type_code" },
        { label: "Is Containerised", value: "derived_is_containerised" },
        {
          label: "HS Code",
          value: "derived_hs_codes_unique",
          isConditionalField: true,
          conditionalComponentData: [
            {
              dependentField: "derived_hs_codes_unique",
              // mappingField: 'hs_code_description_map',
              mappingField: "derived_hs_codes_unique",
              infoText: "Harmonized System Code ranging from 6 to 10 digits, is an international standard to classify traded products.",
              isHSCodeFormatter: true,
              label: "HS Code",
              isReadMore: true,
              readMoreLength: 65,
              isThunderIcon: false,
            },
            {
              dependentField: "derived_estimated_hs_code_unique",
              // mappingField: 'hs_codes_estimated_description_map',
              mappingField: "derived_estimated_hs_code_unique",
              infoText: "These HS Code(s) have been estimated based on the shipment data.",
              isHSCodeFormatter: true,
              label: "Estimated HS Code",
              isReadMore: true,
              readMoreLength: 65,
              hideField: true,
            },
            {
              dependentField: "derived_estimated_hs_code_unique",
              // mappingField: 'hs_code_description_map',
              mappingField: "derived_estimated_hs_code_unique",
              infoText: "Harmonized System Code ranging from 6 to 10 digits, is an international standard to classify traded products.",
              isHSCodeFormatter: true,
              label: "HS Code",
              isReadMore: true,
              readMoreLength: 65,
              isThunderIcon: false,
            },
            {
              dependentField: "",
              mappingField: "",
              infoText: "Harmonized System Code ranging from 6 to 10 digits, is an international standard to classify traded products.",
              isHSCodeFormatter: false,
              label: "HS Code",
              isReadMore: false,
              readMoreLength: 0,
              isThunderIcon: false,
            },
          ],
        },
        { label: "Product Keywords", value: "derived_unique_product_keywords", isReadMore: true, readMoreLength: 160, capitalize: true, infoText: "Product keywords derived from detailed product description on each shipment.", isProductKeywordFormater: true },
        { label: "Estimated Shipment Value", value: "derived_shipment_value", valuePrefix: "USD ", isCommaFormat: true, fixedValueUpto: 2, infoText: "Shipment Value", hideField: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "TEU", value: "derived_shipment_teu", infoText: "Twenty-feet Equivalent Unit", hideField: true },
        { label: "Trade Lanes", value: "derived_index_tradelanes_combined", hideField: true, type: "redirect", redirectionID: "derived_trade_lane_id_combined", profileType: redirectingProfileEnum.tradeLane.key, capitalize: true },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Place of Receipt", value: "place_of_receipt", infoText: "City or Country name in which carrier first took possessionof shipment" },
        { label: "Port of Lading", value: "derived_port_of_lading", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
        { label: "Foreign Port of Lading", value: "foreign_port_of_lading", infoText: "Port in which cargo was laden on the conveyance destined to U.S" },
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: false, countryCodeField: "derived_country_of_origin_code" },
        { label: "Shipper Standardized Name", value: "derived_shipper_master_name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
        { label: "Shipper Jurisdiction Country ", value: "derived_shipper_jurisdiction_country", countryFlag: true, countryCodeField: "derived_shipper_jurisdiction_country_code" },
        { label: "Shipper Name", value: "shipper_party_name", infoText: "Name of the company exporting Shipment" },
        { label: "Shipper Type", value: "derived_is_exporter" },
        { label: "Shipper Address", value: "derived_shipper_full_addr", infoText: "Address of the exporting company", isReadMore: true, readMoreLength: 45 },
        // { label: 'Shipper City', value: 'derived_shipper_city_ml',},
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Port of Unlading", value: "derived_port_of_unlading", infoText: "Port where the goods were unloaded from a seagoing vessel.", tooltip: true, tooltipPrefix: "Port Code: ", tooltipField: "port_of_unlading", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
        { label: "Port of Destination", value: "derived_port_of_destination" },
        { label: "Foreign Port of Destination", value: "foreign_port_of_destination" },
        { label: "Consignee Standardized Name", value: "derived_consignee_master_name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
        { label: "Consignee Jurisdiction Country ", value: "derived_consignee_jurisdiction_country", countryFlag: true, countryCodeField: "derived_consignee_jurisdiction_country_code" },
        { label: "Consignee Name", value: "consignee_name", infoText: "Name of the company importing Shipment", isCapitalise: true },
        { label: "Consignee Type", value: "derived_is_importer" },
        { label: "Consignee Address", value: "derived_consignee_full_addr", infoText: "Address of the importing company", isReadMore: true, readMoreLength: 45 },
        { label: "Consignee City", value: "derived_consignee_city" },
        { label: "Consignee State", value: "derived_consignee_state" },
        { label: "Country of Import", value: "derived_country_of_import" },
        { label: "Consignee Zip Code", value: "derived_consignee_zip_code_clean" },
        { label: "Notify Party Name", value: "derived_notify_party_name" },
        { label: "Notify Party Address", value: "derived_notify_party_full_addr", infoText: "Address of the notify party", isReadMore: true, readMoreLength: 45 },
        { label: "Secondary Notify Party", value: "derived_secondary_notify_parties" },
        // donot remove below commented line
        // { label: 'Secondary Notify Party', value: 'secondary_notify_party_1', isMultiFieldMapping: true, multiFieldsArr: ["secondary_notify_party_1", "secondary_notify_party_2", "secondary_notify_party_3", "secondary_notify_party_4", "secondary_notify_party_5", "secondary_notify_party_6", "secondary_notify_party_7", "secondary_notify_party_8", "secondary_notify_party_9", "secondary_notify_party_10"] },
      ],
    },
    {
      id: 4,
      title: "Carrier Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "VOCC", value: "derived_vocc_master_name", infoText: "Vessel Operating Common Carrier", tooltip: true, tooltipPrefix: "VOCC Code: ", tooltipField: "derived_vocc_code", hideField: true, type: "redirect", redirectionID: "derived_vocc_name_id_combined", profileType: redirectingProfileEnum.vocc.key },
        { label: "NVOCC", value: "derived_nvocc_master_name", infoText: "Non Vessel Operating Common Carrier", tooltip: true, tooltipPrefix: "NVOCC Code: ", tooltipField: "derived_nvocc_code", hideField: true, type: "redirect", redirectionID: "derived_nvocc_name_id_combined", profileType: redirectingProfileEnum.nvocc.key },
        { label: "Voyage Number", value: "voyage_number", isCapitalise: true },
        { label: "Freight Forwarder", value: "derived_freight_forwarder_master_name", type: "redirect", redirectionID: "derived_freight_forwarder_name_id_combined", profileType: redirectingProfileEnum.freightForwarder.key },
        { label: "Carrier Name", value: "derived_carrier_name", infoText: "Carrier Name" },
        { label: "Vessel Name", value: "vessel_name", infoText: "Name of ship used for shipment" },
        { label: "Vessel Type", value: "vessel_type" },
        { label: "Vessel IMO Number", value: "imo_number", preValidate: true },
        { label: "Vessel MMSI Number", value: "mmsi_number", preValidate: true },
        { label: "Vessel Country", value: "vessel_country", countryFlag: true, countryCodeField: "vessel_country_code" },
      ],
    },
    {
      id: 5,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Quantity", value: "manifest_quantity", dynamicUnit: true, unitField: "derived_quantity_unit" },
        { label: "Total Weight", infoText: "Gross weight of shipment", value: "derived_weight", valueSuffix: " Kg", isCommaFormat: true },
        { label: "Container Load", value: "derived_container_load", tooltip: true, tooltipField: "derived_container_load_str", isCapitalise: true },
      ],
    },
    {
      id: 6,
      title: "Container Details",
      growValue: 12,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      isContainer: true,
      mainKey: "container_details",
      uniqueKey: "id",
      data: [
        {
          title: "Container Identifiers",
          titleKey: "",
          isNested: false,
          nestedKey: "",
          uniqueKey: "",
          nestedNumber: "",
          childData: [
            { label: "Container Number", value: "container_number", defaultValue: "NA" },
            { label: "Seal Number", value: "seal_number", defaultValue: "NA" },
            { label: "Type of Service", value: "type_of_service", defaultValue: "NA" },
            { label: "Load Status", value: "load_status", defaultValue: "NA" },
            { label: "Marks & Numbers", value: "marks_and_numbers", defaultValue: "NA" },
            { label: "Equipment Desc.", value: "equipment_description", defaultValue: "NA" },
          ],
        },
        {
          title: "Container Type & Dimension",
          titleKey: "",
          isNested: false,
          isContainerDimension: true,
          nestedKey: "",
          uniqueKey: "",
          nestedNumber: "",
          childData: [
            { label: "Type", value: "type", defaultValue: "NA" },
            { label: "Length", value: "length", defaultValue: "NA", isFeet: true, isInch: true },
            { label: "Width", value: "width", defaultValue: "NA", isFeet: true, isInch: true },
            { label: "Height", value: "height", defaultValue: "NA", isFeet: true, isInch: true },
            { label: "Category", value: "container_category", defaultValue: "NA" },
            { label: "Description", value: "container_description", defaultValue: "NA", isReadMore: true, readMoreLength: 65 },
          ],
        },
        {
          title: "Cargo Description",
          titleKey: "",
          isNested: true,
          nestedKey: "cargo_description_tables",
          nestedNumber: "desc_seq_number",
          childData: [
            { label: "Piece Count", value: "piece_count", defaultValue: "NA", dynamicUnit: true, unitField: "derived_quantity_unit" },
            { label: "Description", value: "cargo_description", defaultValue: "NA", isReadMore: true, readMoreLength: 65 },
            { label: "", value: "table", isTable: true, tableHeaderKey: ["HS Code", "Value (USD)", "Weight (kg)"], tableContentKey: ["hscode", "value", "weight"] },
          ],
        },
        {
          title: "HAZMAT Sequence",
          titleKey: "hazmat_sequence_number",
          isNested: true,
          nestedKey: "hazmat_sequence_tables",
          nestedNumber: "hazmat_sequence_number",
          childData: [
            { label: "Sequence Number", value: "hazmat_sequence_number", defaultValue: "NA" },
            { label: "Code", value: "hazmat_code", defaultValue: "NA" },
            { label: "Class", value: "hazmat_class", defaultValue: "NA" },
            { label: "Code Qualifier", value: "hazmat_code_qualifier", defaultValue: "NA" },
            { label: "Contact", value: "hazmat_contact", defaultValue: "NA" },
            { label: "Flash Point Temp.", value: "hazmat_flash_point_temperature", defaultValue: "NA" },
            { label: "Flash Point Temp. Negative Ind", value: "hazmat_flash_point_temperature_negative_ind", defaultValue: "NA" },
            { label: "Flash Point Temp. Unit", value: "hazmat_flash_point_temperature_unit", defaultValue: "NA" },
            { label: "Description", value: "hazmat_description", defaultValue: "NA" },
            { label: "Classification", value: "hazmat_classification", defaultValue: "NA" },
          ],
        },
      ],
    },
  ],
  onboardingSteps: [
    { selector: "#reacttourdaterange", disableInteraction: true, header: "", description: "Customize your search basis shipment arrival date", float: "", position: "left" },
    { selector: "#reacttourSearchToggle", disableInteraction: true, header: "Normal Search / Advance Search", description: "Use Advance search feature to refine your search", float: "right", position: "bottom" },
    { selector: "#reacttourFilter", disableInteraction: true, header: "Filters Button", description: "Use filters to get most relevant shipments for you", float: "right", position: "right" },
    { selector: "#reacttourMainSearch", disableInteraction: true, header: "Start searching for US Imports Shipments", description: "Entire Bill of Lading, HS Codes, Product Description, Buyers and Suppliers", float: "right", position: "bottom" },
    { selector: "#nav-tab", disableInteraction: true, header: "", description: "View unique consignees, shippers in the search result and add them to your prospect list.", float: "right", position: "bottom" },
    { selector: ".saved-search-button", disableInteraction: true, header: "", description: "Reload from Saved Searches, for quick shipments data access.", float: "", position: "bottom" },
  ],
  specialTooltipKeywords: {
    buyerZipCode: "Buyer Zip Code",
  },
  defaultUeUiSecondLevelKey: "country_of_origin",
  defaultSecondLevelLogisticsTabKey: "derived_shipper_master_name",

  twoColumnMapping: {
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    foreign_port_of_lading: "Foreign ports of lading",
    derived_consignee_state: "Consignee States",
    derived_carrier_name: "Carriers",
    notify_party_name: "Notify Party",
    derived_secondary_notify_parties: "Secondary Notify Party",
    derived_nvocc_name: "NVOCC",
    derived_vocc_name: "VOCC",
    // trade_country: "Trade Routes (Country of Export → Consignee State)",

    derived_consignee_master_name: "Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    derived_port_of_unlading: "Port of Unlading",
    country_of_origin: "Country of Export",
    six_digit_hs_code: "6 digit HS Codes",
    port_of_lading: "Port of Lading",
    trade_port_of_lading_to_unlading: "Trade Routes (Port of lading → US Port of Unlading)",
    derived_freight_forwarder_name: "Freight Forwarders",
  },
};

const UsImportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default UsImportSearch;
